import React from "react";
import { useStyles } from "../../assets/jss/views/Auth";
import clsx from "clsx";
import CustomGrid from "../CustomComponents/CustomGrid/CustomGrid";
import CustomTypography from "../CustomComponents/CustomTypography/CustomTypography";
import NotFoundImg from "../../assets/images/NotFound.png";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const { t } = useTranslation();
  const classes = useStyles();
  const history = useHistory();
  return (
    <>
      <CustomGrid item xs={12} px={6}>
        <CustomTypography
          component="h1"
          variant="h3"
          className={clsx(classes.title, classes.titleNotFound)}
        >
          {t("404")}
        </CustomTypography>
        <CustomTypography
          component="h1"
          variant="h3"
          className={classes.secondaryTitle}
        >
          {t("PAGE_NOT_FOUND")}
        </CustomTypography>
        <img className={classes.errorImg} alt="" src={NotFoundImg} />
        <div onClick={history.goBack} className={classes.errorBack}>
          {t("GO_BACK_TO_THE_PREVIOUS_PAGE")}
        </div>
      </CustomGrid>
    </>
  );
}
